import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'm-success-pull-up',
    components: {},
})
export default class SuccessPullupLayout extends Vue {

    // --------------------------------------------------------
    // Properties

    @Prop()
    private userData: any;

    @Prop()
    private classData: any;

    @Prop()
    private classCode: any;

    // ----------------------------------------------------------------
    // Hooks

    // ------------------------------------------------------------------
    // Actions

    private onDismissPullUp() {
        this.$emit('onDismiss');
    }
}
